import metabolicTadalafilFollowupQuestions from './followup/questions';
import metabolicTadalafilQuestions from './initial/questions';

const tadalafilQuestions = [
  ...metabolicTadalafilQuestions,
  ...metabolicTadalafilFollowupQuestions
];

export default tadalafilQuestions;

export type { MetabolicTadalafilFieldAnswers } from './initial/questions';
export type { MetabolicTadalafilFollowupFieldAnswers } from './followup/questions';
